export enum EMPLOYEE_STATE {
  ACTIVATED = 'ACTIVATED',
  SUSPENDED = 'SUSPENDED',
}

export const EMPLOYEE_STATE_LABEL: Record<EMPLOYEE_STATE, string> = {
  [EMPLOYEE_STATE.ACTIVATED]: '在職',
  [EMPLOYEE_STATE.SUSPENDED]: '已離職',
};

export const EMPLOYEE_STATE_COLOR: Record<EMPLOYEE_STATE, string> = {
  [EMPLOYEE_STATE.ACTIVATED]: 'text-green-500',
  [EMPLOYEE_STATE.SUSPENDED]: 'text-red-500',
};

export enum EMPLOYEE_SALARY_ADJUSTMENT_STATUS {
  PENDING = 'PENDING',
  SETTLED = 'SETTLED',
}

export const EMPLOYEE_SALARY_ADJUSTMENT_STATUS_LABEL: Record<
  EMPLOYEE_SALARY_ADJUSTMENT_STATUS,
  string
> = {
  [EMPLOYEE_SALARY_ADJUSTMENT_STATUS.PENDING]: '待結算',
  [EMPLOYEE_SALARY_ADJUSTMENT_STATUS.SETTLED]: '已結算',
};

export enum EMPLOYEE_PAYROLL_STATUS {
  DRAFT = 'DRAFT',
  REVIEWING = 'REVIEWING',
  EMPLOYEE_CONFIRMING = 'EMPLOYEE_CONFIRMING',
  EMPLOYEE_DISPUTED = 'EMPLOYEE_DISPUTED',
  READY_FOR_PAY = 'READY_FOR_PAY',
  PAID = 'PAID',
  VOIDED = 'VOIDED',
}

export const EMPLOYEE_PAYROLL_STATUS_LABEL: Record<
  EMPLOYEE_PAYROLL_STATUS,
  string
> = {
  [EMPLOYEE_PAYROLL_STATUS.DRAFT]: '已建立',
  [EMPLOYEE_PAYROLL_STATUS.REVIEWING]: '審核中',
  [EMPLOYEE_PAYROLL_STATUS.EMPLOYEE_CONFIRMING]: '員工確認中',
  [EMPLOYEE_PAYROLL_STATUS.EMPLOYEE_DISPUTED]: '員工有異議',
  [EMPLOYEE_PAYROLL_STATUS.READY_FOR_PAY]: '待匯款',
  [EMPLOYEE_PAYROLL_STATUS.PAID]: '已匯款',
  [EMPLOYEE_PAYROLL_STATUS.VOIDED]: '已作廢',
};

export const EMPLOYEE_PAYROLL_STATUS_COLOR: Record<
  EMPLOYEE_PAYROLL_STATUS,
  string
> = {
  [EMPLOYEE_PAYROLL_STATUS.DRAFT]: 'text-gray-500',
  [EMPLOYEE_PAYROLL_STATUS.REVIEWING]: 'text-gray-500',
  [EMPLOYEE_PAYROLL_STATUS.EMPLOYEE_CONFIRMING]: '',
  [EMPLOYEE_PAYROLL_STATUS.EMPLOYEE_DISPUTED]: 'text-orange-500',
  [EMPLOYEE_PAYROLL_STATUS.READY_FOR_PAY]: '',
  [EMPLOYEE_PAYROLL_STATUS.PAID]: 'text-green-500',
  [EMPLOYEE_PAYROLL_STATUS.VOIDED]: 'text-red-500',
};
